if (!customElements.get('quick-add-minicart')) {
  customElements.define(
    'quick-add-minicart',
    class QuickAddMinicart extends HTMLElement {
      constructor() {
        super();

        this.select = this.querySelector('select');
        this.options = this.select.querySelectorAll('option');
        this.buttonOpenSize = this.querySelector('.quick-add__submit');
        this.modalSize = this.querySelector('.card-product-variant-options-list');
        this.radios = this.modalSize.querySelectorAll('.card-product-radio-input');
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-drawer-items')
        this.updateAvailableSize();

        this.buttonOpenSize.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
        
        this.addEventListener('change', this.onSubmitHandler.bind(this));
      }

      open() {
        this.modalSize.classList.remove('hidden');
        this.buttonOpenSize.classList.add('hidden');
      }

      close () {
        this.modalSize.classList.add('hidden');
        this.buttonOpenSize.classList.remove('hidden');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.onSubmitForm();
      }

      onSubmitForm() {
        this.radios.forEach((radio) => {
          if (radio.checked) {
            this.currentSize = radio.value;
            return;
          }
        });

        this.options.forEach((option) => {
          option.checked = false;
          if (option.getAttribute('data-option-value').includes(this.currentSize)) {
            option.checked = true;
            this.select.value = option.value;
            this.currentVariant = option.value;
          }
        })

        if (this.buttonOpenSize.getAttribute('aria-disabled') === 'true') return;

        this.buttonOpenSize.setAttribute('aria-disabled', true);
        this.buttonOpenSize.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = {
        'items': [{
          'id': parseInt(this.currentVariant),
          'quantity': 1
          }]
        };
        //config.body = JSON.stringify(formData);
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(formData);
        config.headers = {
          'Content-Type': 'application/json'
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', config)
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log("Cart updated:", data);

          if (data.sections) {
            for (const [sectionId, html] of Object.entries(data.sections)) {
              const sectionElement = document.getElementById(sectionId);
              if (sectionElement) {
                sectionElement.innerHTML = html;
              }
            }

            const cartCountElement = document.querySelector(".cart-count-bubble span[aria-hidden='true']");
            if (cartCountElement) {
              const cartQuantity = cartCountElement.textContent.trim();
              document.querySelector(".drawer__header .drawer__header__cart-item-count span").textContent = cartQuantity;
            }
            window.dispatchEvent(new CustomEvent('abra:render'));
          }
        })
        .finally(() => {
          this.close();
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.buttonOpenSize.classList.remove('loading');
          this.buttonOpenSize.setAttribute('aria-disabled', false);
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          } else {
            this.cartItems.onCartUpdate();
          }

        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      updateAvailableSize() {
        let count = 0;
        this.radios.forEach((radio) => {
          const size = radio.value;
          let available = true;
          this.options.forEach((option) => {
            if (option.getAttribute('data-option-value').includes(size)) {
              if (option.getAttribute('disabled')) {
                available = false;
                count = count + 1;
                return;
              }
            }
          })
          if (!available) {
            radio.classList.add('disabled');
          }
        })
        if (count === this.radios.length) {
          this.buttonOpenSize.classList.add('diasbled');
          this.buttonOpenSize.querySelector('.sold-out-message').classList.remove('hidden');
          this.buttonOpenSize.querySelector('.quick-add-text').classList.add('hidden');
        }
      }
    },
  );
}
  